import { MigrationDefinition } from './migration.types';

/**
 * Migration: V2 → V3
 *
 * Upgrade:
 * - substratfeuchte zwischen header/extendedHeader verschieben
 *   (Hinweis: Die Original-Migration macht header→extendedHeader→header,
 *    was effektiv ein No-Op ist. Wir behalten das Verhalten bei.)
 *
 * Downgrade:
 * - Keine Änderungen nötig (war bereits ein No-Op)
 */
export const migrationV2ToV3: MigrationDefinition = {
  fromVersion: 2,
  toVersion: 3,

  upgrade(doc: any): any {
    // Originalcode macht: header.substratfeuchte → extendedHeader.substratfeuchte → header.substratfeuchte
    // Das ist effektiv ein No-Op, aber wir behalten es bei für Kompatibilität
    if (doc.extendedHeader) {
      doc.extendedHeader.substratfeuchte = doc.header?.substratfeuchte;
      delete doc.header?.substratfeuchte;

      doc.header.substratfeuchte = doc.extendedHeader.substratfeuchte;
      delete doc.extendedHeader.substratfeuchte;
    }

    doc.version = 3;
    return doc;
  },

  downgrade(doc: any): any {
    // Keine Änderungen nötig - Migration war bereits ein No-Op
    doc.version = 2;
    return doc;
  },

  dataLossWarnings: []
};
